import { useCallback } from 'react';
import { useRegistration } from '@/context/RegistrationContext';
import { useAnalytics } from '@/hooks/useAnalytics';
import { useReCaptcha } from '@/hooks/useReCaptcha';
import { useOtpLink } from '@/hooks/useOtpLink';
import { apiClient } from '@/services/api';

export const useDownloadSMS = () => {
  const { registrationData } = useRegistration();
  const { executeReCaptcha } = useReCaptcha({ screen: 'send_download_sms' });
  const { getOtpLink } = useOtpLink();
  const { track } = useAnalytics();

  const sendDownloadSMS = useCallback(
    async (
      actionName: string,
      phoneNumber?: string,
      callback?: (success: boolean) => void,
    ): Promise<boolean> => {
      const numberToSendSMS = phoneNumber || registrationData.account.phoneNumber;

      if (!numberToSendSMS) {
        console.error('No phone number available for SMS');

        if (callback) {
          callback(false);
        }
        return false;
      }

      try {
        const otpLink = getOtpLink();
        const token = await executeReCaptcha(actionName);

        if (!token) {
          throw new Error('reCAPTCHA validation failed');
        }

        const response = await apiClient.downloadSMS(numberToSendSMS, token, otpLink);

        if (response === 'Success') {
          if (callback) {
            callback(true);
          }
          return true;
        } else {
          if (callback) {
            callback(false);
          }
          return false;
        }
      } catch (error) {
        console.error('Failed to send download SMS:', error);

        if (callback) {
          callback(false);
        }
        return false;
      }
    },
    [registrationData.account.phoneNumber, executeReCaptcha, getOtpLink, track],
  );

  return { sendDownloadSMS };
};
